import { dimensions, SvgIconProps } from "./SvgIcon";

export const BulbIcon = (props: SvgIconProps) => {
  const { width, height } = dimensions(props);
  return (
    <svg
      style={{ display: "block", ...props.style }}
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 1V1.5M1.5 6H1M2.75 2.75L2.44995 2.44995M9.25 2.75L9.55012 2.44995M11 6H10.5M5 6.75H7M6 6.75V9.25M7.75 8.43698C8.50703 7.89239 9 7.00376 9 6C9 4.34315 7.65685 3 6 3C4.34315 3 3 4.34315 3 6C3 7.00376 3.49297 7.89239 4.25 8.43698V9.4C4.25 9.96005 4.25 10.2401 4.35899 10.454C4.45487 10.6422 4.60785 10.7951 4.79601 10.891C5.00992 11 5.28995 11 5.85 11H6.15C6.71005 11 6.99008 11 7.20399 10.891C7.39215 10.7951 7.54513 10.6422 7.64101 10.454C7.75 10.2401 7.75 9.96005 7.75 9.4V8.43698Z"
        stroke="#667085"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
